import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconCaptionsFilledStyle0 = cosmosIconCss;

const CosmosIconCaptionsFilled$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconCaptionsFilled extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '0226b238b2bf0d38709f6b09493173044e8e5280', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'e4e7e016c8528853e020906f2e0f106aff980981', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '8dffd81a7e35e4e67db46943057d48938868071e', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M19.5 4h-17c-.276 0-.5.241-.5.538v12.924c0 .297.224.538.5.538h17c.276 0 .5-.241.5-.538V4.538c0-.297-.224-.538-.5-.538Zm-1 1.5v11h-15v-11h15Zm-14 10v-9h13v9h-13Zm4.06-3.523a.866.866 0 0 0 .754-.403.275.275 0 0 1 .242-.158h.763c.138 0 .205.088.173.202a1.856 1.856 0 0 1-1.924 1.377 1.96 1.96 0 0 1-1.787-.967 2.023 2.023 0 0 1 0-2.056 1.96 1.96 0 0 1 1.787-.967 1.868 1.868 0 0 1 1.924 1.333c.027.114-.035.201-.173.201h-.777a.284.284 0 0 1-.235-.14.87.87 0 0 0-.744-.377.895.895 0 0 0-.665.285.923.923 0 0 0-.246.688.926.926 0 0 0 .243.693.897.897 0 0 0 .665.289Zm5 0h-.001.003-.002Zm.754-.403a.866.866 0 0 1-.754.403.896.896 0 0 1-.667-.287.924.924 0 0 1-.244-.695.923.923 0 0 1 .246-.688.895.895 0 0 1 .664-.285.872.872 0 0 1 .746.377c.05.084.137.137.234.14h.78c.139 0 .2-.087.174-.201a1.869 1.869 0 0 0-1.925-1.333 1.96 1.96 0 0 0-1.787.967 2.023 2.023 0 0 0 0 2.056 1.96 1.96 0 0 0 1.787.967c.883.066 1.69-.51 1.925-1.377.03-.114-.035-.202-.174-.202h-.763a.274.274 0 0 0-.242.158Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconCaptionsFilledStyle0; }
}, [1, "cosmos-icon-captions-filled", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-captions-filled"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-captions-filled":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconCaptionsFilled$1);
            }
            break;
    } });
}

const CosmosIconCaptionsFilled = CosmosIconCaptionsFilled$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconCaptionsFilled, defineCustomElement };
